import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { authApi } from '../lib/api';

const ForgotPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location?.pathname || '';
  const isFR = pathname.startsWith('/fr');
  const backHref = isFR ? '/fr/signin' : '/signin';

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) {
      setError(isFR ? 'Indiquez votre email.' : 'Please enter your email.');
      return;
    }
    setLoading(true);
    try {
      await authApi.forgotPassword(email, isFR ? 'fr' : 'en');
      setSent(true);
    } catch (err) {
      setError((err instanceof Error ? err.message : '') || (isFR ? 'Une erreur est survenue.' : 'An error occurred.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#3C59B2]/10 flex items-center justify-center p-4">
      <div className="font-manrope w-full max-w-lg bg-white border border-[#E2E8F0] rounded-3xl overflow-hidden card-hover shadow-xl">
        <div className="bg-[#3C59B2] p-8 text-white">
          <a href={backHref} className="flex items-center space-x-2 mb-6 cursor-pointer hover:opacity-80 transition-opacity inline-block">
            <ArrowLeft className="w-5 h-5" />
            <span className="text-sm">{isFR ? 'Retour' : 'Back'}</span>
          </a>
          <h1 className="text-2xl font-bold">
            {isFR ? 'Mot de passe oublié' : 'Forgot password'}
          </h1>
          <p className="text-blue-100 mt-2">
            {isFR
              ? 'Entrez votre email pour recevoir un lien de réinitialisation (valide 1 h).'
              : 'Enter your email to receive a reset link (valid 1 hour).'}
          </p>
        </div>
        <div className="p-8">
          {sent ? (
            <div className="text-center">
              <p className="text-gray-700 mb-4">
                {isFR
                  ? "Si un compte existe pour cet email, vous recevrez un lien pour réinitialiser votre mot de passe. Pensez à vérifier les spams."
                  : "If an account exists for this email, you'll receive a reset link. Check your spam folder."}
              </p>
              <button
                type="button"
                onClick={() => navigate(backHref)}
                className="btn-premium overflow-hidden px-6 py-3 rounded-full font-semibold bg-[#3C59B2] text-white hover:bg-[#2d4a8f]"
              >
                {isFR ? 'Retour à la connexion' : 'Back to sign in'}
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                {isFR ? 'Email' : 'Email'}
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="vous@exemple.com"
                className="w-full border border-gray-300 rounded-xl px-4 py-3 mb-4 focus:ring-2 focus:ring-[#3C59B2] focus:border-[#3C59B2]"
                autoFocus
                disabled={loading}
              />
              {error && <p className="text-red-600 text-sm mb-4">{error}</p>}
              <button
                type="submit"
                disabled={loading}
                className="btn-premium overflow-hidden w-full py-3 rounded-full font-semibold bg-[#3C59B2] text-white hover:bg-[#2d4a8f] disabled:opacity-50"
              >
                {loading ? (isFR ? 'Envoi...' : 'Sending...') : (isFR ? 'Envoyer le lien' : 'Send reset link')}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
